import React from 'react';
import App from './App';
import MaintenanceScreen from './MaintenanceScreen';
import './maintenance.css';

const MAINTENANCE_MODE = false;

export default function MaintenanceGate() {
  const isLocalhost =
    typeof window !== 'undefined' &&
    (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname === '::1'
    );

  // En local, même avec Wrangler, on laisse accéder au vrai site
  // pour tester les comptes, D1 et les Functions.
  if (isLocalhost) {
    return <App />;
  }

  // Sur le vrai site, la maintenance est active si elle est à true.
  return MAINTENANCE_MODE ? <MaintenanceScreen /> : <App />;
}